import { Component } from "react";
import { formatDate } from "../../common/services/utilities";
import ThemeableAgGrid from "../../common/components/agGrid/ThemeableAgGrid";
import { withTranslation } from "react-i18next";

class AlbertaEnvironmentalIssuesTable extends Component {
  columns = [
    //{field: 'TransactionId', label: this.props.t("TransactionId")},
    {
      field: "TransactionDate",
      headerName: this.props.t("TransactionDate"),
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Owner",
      headerName: this.props.t("Owner"),
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Quantity",
      headerName: this.props.t("Quantity"),
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Registry",
      headerName: this.props.t("Registry"),
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Vintage",
      headerName: this.props.t("Vintage"),
      filter: false,
      floatingFilter: false,
    },
    {
      field: "QuantificationProtocol",
      headerName: this.props.t("QuantificationProtocol"),
      filter: false,
      floatingFilter: false,
    },
    {
      field: "SerialStart",
      headerName: this.props.t("SerialStart"),
      filter: false,
      floatingFilter: false,
    },
    {
      field: "SerialEnd",
      headerName: this.props.t("SerialEnd"),
      filter: false,
      floatingFilter: false,
    },
  ];

  mapToViewModel(issues) {
    return issues.map((issue, index) => ({
      index: index,
      Id: issue.Id,
      TransactionId: issue.TransactionId,
      TransactionDate: formatDate(issue.TransactionDate),
      Owner: issue.Owner,
      Quantity: issue.Quantity,
      Registry: issue.Registry,
      Vintage: issue.Vintage,
      QuantificationProtocol: issue.QuantificationProtocol,
      SerialStart: issue.SerialStart,
      SerialEnd: issue.SerialEnd,
    }));
  }

  render() {
    const { issues, onRowClick } = this.props;

    const mappedIssues = this.mapToViewModel(issues);

    // Pagination configuration
    const paginationConfig = {
      // Enable pagination for all tables regardless of size
      enabled: true,
      // Default page size
      pageSize: 20,
      // Available page size options for user to choose
      pageSizeOptions: [5, 10, 20, 50, 100],
    };

    return (
      <ThemeableAgGrid
        className="table-extra-small"
        columnDefs={this.columns}
        rowData={mappedIssues}
        onRowClick={onRowClick}
        pagination={true}
        paginationPageSize={paginationConfig.pageSize}
        paginationPageSizeSelector={paginationConfig.pageSizeOptions}
        suppressPaginationPanel={false}
        allowHorizontalScroll={false}
      />
    );
  }
}

export default withTranslation(["marketdata"])(AlbertaEnvironmentalIssuesTable);
